import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AuthService } from 'src/app/facade/auth/auth.service';
import { NbToastrService } from '@nebular/theme';
import { switchMap } from 'rxjs/operators';

@Component({
	selector: 'app-reset-password-parent',
	templateUrl: './reset-password-parent.component.html',
	styleUrls: ['./reset-password-parent.component.scss']
})
export class ResetPasswordParentComponent implements OnInit {
	resetToken;

	userDataForReset;

	requesting = false;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private authService: AuthService,
		private toastrService: NbToastrService
	) {}

	ngOnInit() {
		this.route.params
			.pipe(
				switchMap(async (params: Params) => {
					this.resetToken = params.guidToken;
				})
			)
			.subscribe();

		this.authService.verifyResetToken(this.resetToken).subscribe(
			result => {
				this.userDataForReset = result['data']['verifyResetToken'].user;
			},
			error => {
				console.log(error);
			}
		);
	}

	handleResetPassword(formValue) {
		console.log(formValue);

		this.requesting = true;

		this.authService
			.changePasswordWithToken(
				formValue,
				this.userDataForReset,
				this.resetToken
			)
			.subscribe(
				result => {
					this.showToast('Fjalëkalimi u rivendos me sukses!', '');

					this.requesting = false;

					this.router.navigate(['/login']);
				},
				error => {
					console.log(error);

					this.showToast('Ops, Ju lutem provoni përsëri!', '');

					this.requesting = false;
				}
			);
	}

	showToast(position, status) {
		this.toastrService.show(status, position);
	}
}
